import { useEffect } from "react";

const BOOTSTRAP_ID = "bootstrap-dynamic-css";
const BOOTSTRAP_ICONS_ID = "bootstrap-icons-dynamic-css";

let refCount = 0;

/**
 * Dynamically loads Bootstrap CSS and Bootstrap Icons CSS when a component mounts,
 * and removes them when all consumers unmount. This prevents Bootstrap styles
 * from bleeding into non-login pages.
 */
const useBootstrapCSS = () => {
  useEffect(() => {
    refCount++;

    if (!document.getElementById(BOOTSTRAP_ID)) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = `${process.env.PUBLIC_URL}/css/bootstrap.min.css`;
      link.id = BOOTSTRAP_ID;
      document.head.appendChild(link);
    }

    if (!document.getElementById(BOOTSTRAP_ICONS_ID)) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href =
        "https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.css";
      link.id = BOOTSTRAP_ICONS_ID;
      document.head.appendChild(link);
    }

    return () => {
      refCount--;
      if (refCount === 0) {
        document.getElementById(BOOTSTRAP_ID)?.remove();
        document.getElementById(BOOTSTRAP_ICONS_ID)?.remove();
      }
    };
  }, []);
};

export default useBootstrapCSS;
